import SearchInput from "./inputs/Search";
import { Button, Dropdown, Grid, Menu } from "antd";
import { routes } from "@/router/constants";
import { useHistory, useLocation } from "react-router-dom";
import logoHeader1 from "@/assets/images/new-design/logo-header1.png";
import { IS_DEV } from "@/utils/constant";
import { useState, useEffect, useRef } from "react";
import { cn } from "@/utils/util";
const { useBreakpoint } = Grid;

// Primary menu items (always visible)
const allMenuItems = [
  {
    key: "explore",
    title: "Explore",
    path: routes.EXPLORE_NFT,
    type: "button",
    className: "btn-menu",
  },
  {
    key: "stats",
    title: "Stats",
    path: "/",
    type: "button",
    className: "btn-menu",
    submenu: [
      { title: "Rankings", key: "1", path: "/ranking" },
      { title: "Activities", key: "2", path: "/activities" },
    ],
  },
  // {
  //   key: "launchpad",
  //   title: "Launchpad",
  //   path: routes.LAUNCHPAD,
  //   type: "button",
  //   className: "btn-menu",
  // },
  {
    key: "lottery",
    title: "Lottery",
    path: routes.LOTTERY,
    type: "button",
    className: "btn-menu",
  },
  {
    key: "lucky_draw",
    title: "Lucky Draw",
    path: routes.LUCKY_DRAW,
    className: "btn-menu",
  },
  {
    key: "sanh",
    title: "SANH",
    path: routes.SanhPackage,
    className: "btn-menu",
  },
  {
    key: "swap",
    title: "Swap",
    path: routes.SWAP,
    className: "btn-menu",
  },
  {
    key: "bcc",
    title: "BCC",
    path: routes.BCC,
    className: "btn-menu",
  },
].filter(_item => !_item?.hidden);

const HeaderLeft = () => {
  const history = useHistory();
  const location = useLocation();
  const breakPoint = useBreakpoint();
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const inputRef = useRef<any>(null);

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };

  // Collapse search on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isSearchFocused) {
        setIsSearchFocused(false);
        // Blur the input to remove focus
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSearchFocused]);

  return (
    <div className="header-left-wrapper">
      <img
        src={logoHeader1}
        alt=""
        className="anticon-logo"
        onClick={() => history.push({ pathname: routes.HOMEPAGE })}
      />
      {breakPoint?.lg && (
        <div className={`search-container ${isSearchFocused ? "expanded" : "collapsed"}`}>
          <SearchInput
            ref={inputRef}
            whiteBg={[routes.LAUNCHPAD, routes.RANKING, routes.EXPLORE_NFT].includes(location.pathname)}
            onFocus={handleSearchFocus}
            onBlur={handleSearchBlur}
            isCollapsed={!isSearchFocused}
          />
        </div>
      )}
      <div className="group-btn gap-6 w-full">
        {allMenuItems.map(item => (
          <MenuItem item={item} key={item?.key} />
        ))}
      </div>
    </div>
  );
};

// Render a menu button (with or without submenu)
const MenuItem = ({ item }: { item: any }) => {
  const history = useHistory();
  const location = useLocation();
  function handleChangePage(path: string) {
    history.push({ pathname: path });
  }

  if (item?.submenu && item?.submenu?.length > 0) {
    const menuCreate = (
      <Menu>
        {item?.submenu.map((_submenu: any) => {
          return (
            <Menu.Item key={_submenu.key} onClick={() => handleChangePage(_submenu?.path ?? "/")}>
              <p
                className={cn(
                  `p-0.5 text-base font-bold`,
                  location.pathname === _submenu.path ? "text-[#2750FB]" : "text-text",
                )}>
                {_submenu?.title}
              </p>
            </Menu.Item>
          );
        })}
      </Menu>
    );
    return (
      <Dropdown
        overlay={menuCreate}
        placement="bottom"
        trigger={["hover", "click"]}
        key={item?.key}
        overlayClassName="header-dropdown">
        <Button key={item?.key} type="link" className={`${item?.className} !p-0`}>
          {item?.title}
        </Button>
      </Dropdown>
    );
  }
  return (
    <Button
      onClick={() => handleChangePage(item?.path ?? "")}
      key={item?.key}
      type="link"
      className={`${item?.className} !p-0 ${location.pathname === item.path ? "!text-[#2750FB]" : ""}`}>
      {item?.title}
    </Button>
  );
};

export default HeaderLeft;
